import React, { useState } from "react";
import axios from "axios";
import { backendUrl } from "../../../constants";

function Admintransferform() {
  const [teacherData, setTeacherData] = React.useState({
    teacher: [
      {
        id: 1892332,
        name: "ramesh",
        dob: "12-11-1980",
        pos: "S.G.T",
        schl: "MPUPS",
        salary: "8,90,000",
      },
    ],
  });
  const [id, setId] = useState("0");
  function listQ() {

    var e = document.getElementById("list");

    setId(e.value);
  }
  const [value, setValue] = React.useState("");
  const [data, setData] = React.useState({
    state: "",
    school: "",
    district: "",
  });
  const submit = (e) => {
    e.preventDefault();
    if (value !== "") {
      axios({
        method: "post",
        url: `${backendUrl}/viewTeacher`,
        data: {
          "ownerEmail": localStorage.getItem("email"),
          "ownerPassword": localStorage.getItem("password"),
          "teacherId": value
        }
      }).then(res => {
        console.log(res.data);
        const extraDetails = JSON.parse(res.data.teacher.extraDetails);
        console.log(extraDetails);
        const data = {
          "teacher": [
            {
              "id": extraDetails.teacherId,
              "name": extraDetails.name,
              "dob": res.data.teacher.teacherDOB,
              "pos": extraDetails.position,
              "schl": res.data.teacher.school_code,
              "salary": extraDetails.salary,
              "tlink": "/view-teacherprofile"
            }
          ]
        }
        setTeacherData(data);
      }).catch(err => {
        console.log(err);
      });
    }
    else {
      console.log(data);
      axios({
        method: "post",
        url: `${backendUrl}/viewTeacherV2`,
        data: {
          "ownerEmail": localStorage.getItem("email"),
          "ownerPassword": localStorage.getItem("password"),
          "state": data.state,
          "district": data.district,
          "school": data.school
        },
      }).then(res => {
        console.log(res.data);
        setTeacherData({
          "teacher": res.data.teachers
        });
      }).catch(err => {
        console.log(err);
      });
    }
  }
  const [transfer, setTransfer] = React.useState({
    teacherId: "",
    school: "",
    district: "",
    state: "",
    dateOfTransfer: "",
    transferLetter:null
  });

  const transferSubmit = (e) => {
    e.preventDefault();
    console.log(transfer);
    axios({
      method: "post",
      url: `${backendUrl}/transferTeacher`,
      data: {
        "ownerEmail": localStorage.getItem("email"),
        "ownerPassword": localStorage.getItem("password"),
        "teacherId": transfer.teacherId,
        "school_code": transfer.school,
        "district": transfer.district,
        "state": transfer.state,
        "dateOfTransfer": transfer.dateOfTransfer,
        "transferLetter":transfer.transferLetter
      }
    }).then(res => {
      console.log(res.data);
    }).catch(err => {
      console.log(err);
    })
  }

  return (
    <>
      <div className="main-container">
        <div className="pd-ltr-20 xs-pd-20-10">
          <div className="min-height-200px">
            <div className="page-header">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="title">
                    <h4>Transfer Teacher</h4>
                  </div>
                  <nav aria-label="breadcrumb" role="navigation">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="index.html">Home</a>
                      </li>
                      <li className="breadcrumb-item">Transfers</li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Transfer Teacher
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
            <div className="pd-20 card-box mb-30">
              <div className="wizard-content">
                <form className="tab-wizard wizard-circle wizard">
                  <section>
                    <div className="card-box mb-30 pd-20">
                      <div className="row">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Teacher:</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Teacher ID"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <label>OR</label>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>State :</label>
                              <select className="custom-select form-control" onChange={(e) => {
                                setData({ ...data, state: e.target.value });
                              }}>
                                <option value="">Select State</option>
                                <option value="Maharashtra">Maharashtra</option>
                                <option value="Telangana">Telangana</option>
                                <option value="Andhra Pradesh">Andhra Pradesh</option>
                                <option value="Karnataka">Karnataka</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>District :</label>
                              <select onChange={(e) => {
                                setData({ ...data, district: e.target.value });
                              }} className="custom-select form-control">
                                <option value="">Select District</option>
                                <option value="Nagpur">Nagpur</option>
                                <option value="Thane">Thane</option>
                                <option value="Nashik">Nashik</option>
                                <option value="Kolhapur">Kolhapur</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>School :</label>
                              <select onChange={(e) => {
                                setData({ ...data, school: e.target.value });
                              }} className="custom-select form-control">
                                <option value="">Select School</option>
                                <option value="ZPHSP">ZPHS, Pune</option>
                                <option value="ZPHST">ZPHS, Thane</option>
                                <option value="ZPHSN">ZPHS, Nashik</option>
                                <option value="ZPHSND">ZPHS, Nanded</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-12 col-md-12 col-form-label"></label>
                          <div className="col-sm-12 col-md-10">
                            <input
                              className="btn btn-primary"
                              type="submit"
                              defaultValue="Submit"
                              onClick={submit}
                            />
                          </div>
                        </div>

                        <div className="pd-20">
                          <h4 className="text-blue h4">Teacher Details</h4>
                        </div>
                        <div className="pb-20">
                          <table className="data-table datatable-nosort table table-responsive-md stripe hover nowrap ">
                            <thead className="thead-dark">
                              <tr>
                                <th className="table-plus datatable-nosort">
                                  Teacher ID
                                </th>
                                <th>Teacher Name</th>
                                <th>Date of Birth</th>
                                <th>Current Position</th>
                                <th>Current School</th>
                                <th className="datatable-nosort">Salary</th>
                              </tr>
                            </thead>
                            <tbody>
                              {teacherData.teacher.map(function (td, i) {
                                return (
                                  <tr>
                                    <td className="table-plus">{td.id}</td>
                                    <td>{td.name}</td>
                                    <td>{td.dob}</td>
                                    <td>{td.pos}</td>
                                    <td>{td.schl}</td>
                                    <td>{td.salary}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card-box mb-30">
                      <div className="pd-20">
                        <div>
                          <h4 className="text-blue h4">
                            Transfer School Details
                          </h4>
                        </div>
                        <div>
                        <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Teacher Id:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Teacher Id"
                                  onChange={(e) => {
                                    setTransfer({ ...transfer, teacherId: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date of transfer:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter date"
                                  onChange={(e) => {
                                    setTransfer({ ...transfer, dateOfTransfer: e.target.value });
                                  }}
                                  value={transfer.dateOfTransfer}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>State :</label>
                                <select className="custom-select form-control" onChange={(e) =>{
                                  setTransfer({ ...transfer, state: e.target.value });
                                }}>
                                  <option value="">Select State</option>
                                  <option value="Maharashtra">
                                    Maharashtra
                                  </option>
                                  <option value="Telangana">
                                    Telangana
                                  </option>
                                  <option value="Andhra Pradesh">
                                    Andhra Pradesh
                                  </option>
                                  <option value="Karnataka">
                                    Karnataka
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>District :</label>
                                <select className="custom-select form-control" onChange={(e) =>{
                                  setTransfer({ ...transfer, district: e.target.value });
                                }}>
                                  <option value="">Select District</option>
                                  <option value="Nagpur">Nagpur</option>
                                  <option value="Thane">Thane</option>
                                  <option value="Nashik">Nashik</option>
                                  <option value="Kolhapur">Kolhapur</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>School :</label>
                                <input className=" form-control" onChange={(e)=>{
                                  setTransfer({ ...transfer, school: e.target.value });
                                }}>
                                </input>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-8 ">
                                <div class="form-group">
                                  <label>Upload Transfer Letter:</label>
                                  <div class="custom-file ">
                                    <input
                                      type="file"
                                      class="custom-file-input"
                                      onChange={(e) => {
                                        setTransfer({ ...transfer, transferLetter: e.target.files[0] });
                                      }}
                                    />
                                    <label class="custom-file-label">
                                      Choose file
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-8">
                                <div className="custom-control custom-checkbox mb-5">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customCheck2"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customCheck2"
                                  >
                                    I agree that I'm responsible for the above
                                    chnages made to the data
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-10">
                              <input
                                className="btn btn-primary"
                                type="submit"
                                defaultValue="Submit"
                                onClick={transferSubmit}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Admintransferform;
